import * as React from 'react';
import { jaxa } from '../../App';
import Swal from 'sweetalert2';
import { columns2 } from './gridData';
import CreateInvoice from './CreateInvoice';
import { CustomizedDataGrid } from '../../components';
import { RefreshRounded as RefreshIcon } from '@mui/icons-material';
import { Box, Typography, Button, Backdrop, CircularProgress, IconButton } from '@mui/material';

export default function Admin() {

    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    const [invoiceId, setInvoiceId] = React.useState(null);

    const [invoices, setInvoices] = React.useState([]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const clear = () => setInvoiceId(null);

    const getInvoiceData = async() => {
        setLoading(true);
        await jaxa.get('/get-invoices').then((res) => setInvoices(res.data)).catch((e) => {
            Swal.fire({ title: 'Failed to get invoices' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
    };

    React.useEffect(() => {
        getInvoiceData();
    }, []);

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress/>
        </Backdrop>
    ), []);

    return (

        <Box sx={{ width: '100%', height: '100vh' }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: 2 }}>
                <Typography component="h2" variant="h6" sx={{ mb: 2 }}>Invoice</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton onClick={getInvoiceData}>
                        <RefreshIcon/>
                    </IconButton>
                    <Button variant="outlined" disabled={loading} onClick={handleOpen} sx={{ ml: 2 }}>CREATE</Button>
                </Box>
            </Box>
            <CustomizedDataGrid columns={columns2} rows={invoices} onClick={e => setInvoiceId(e)}/>
            {open ? <CreateInvoice open={open} handleClose={handleClose}/> : null}
            {invoiceId ? <CreateInvoice view invoiceId={invoiceId} open={Boolean(invoiceId)} handleClose={clear}/> : null}
            {loading ? loader : null}
        </Box>

    );

};